import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
//Material imports
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import CloudDownload from "@material-ui/icons/CloudDownload";
import CloudOff from "@material-ui/icons/CloudOff";
import Icon from "@material-ui/core/Icon"; //Limitess imports

import { withi18n } from "../hocs/i18n";
import { isFileTypeImage } from "../../../common/utils";
var imageFileW = 200;
var otherFileW = 120;

var AttachmentBody = /*#__PURE__*/function (_PureComponent) {
  _inherits(AttachmentBody, _PureComponent);

  var _super = _createSuper(AttachmentBody);

  function AttachmentBody(props) {
    var _this;

    _classCallCheck(this, AttachmentBody);

    _this = _super.call(this, props);
    _this.state = {
      isValidURL: props.attachment.valid,
      mouseHover: false,
      isImageFile: isFileTypeImage(props.attachment.contentType)
    };
    return _this;
  }

  _createClass(AttachmentBody, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          attachment = _this$props.attachment,
          classes = _this$props.classes,
          t = _this$props.t,
          backgroundStyle = _this$props.backgroundStyle,
          isCustomer = _this$props.isCustomer,
          textStyling = _this$props.textStyling;
      var _this$state = this.state,
          isValidURL = _this$state.isValidURL,
          mouseHover = _this$state.mouseHover,
          isImageFile = _this$state.isImageFile;
      return /*#__PURE__*/React.createElement("div", {
        id: "attchmentBody",
        style: isCustomer ? {
          left: "calc(100% - ".concat((isImageFile && isValidURL ? imageFileW : otherFileW) + 10, "px)")
        } : {},
        className: "".concat(isValidURL ? classes.cursorPointer : "", " ").concat(classes.listItem, " ").concat(backgroundStyle, " ").concat(isImageFile && isValidURL ? classes.image : classes.file),
        onMouseOver: function onMouseOver() {
          _this2.setState({
            mouseHover: true
          });
        },
        onMouseOut: function onMouseOut() {
          _this2.setState({
            mouseHover: false
          });
        },
        onClick: function onClick() {
          if (isValidURL) {
            window.open(attachment.url, "_blank");
          }
        }
      }, isValidURL && isImageFile && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.imageOverlay, " ").concat(mouseHover ? classes.showOverlay : classes.hideOverlay)
      }, /*#__PURE__*/React.createElement(Typography, {
        component: "div"
      }, t("click to download")), /*#__PURE__*/React.createElement(Icon, {
        className: classes.iconContainer
      }, /*#__PURE__*/React.createElement(CloudDownload, {
        className: classes.icon
      })), /*#__PURE__*/React.createElement(Typography, {
        component: "div",
        className: "".concat(classes.fileNameEllipsis, " ").concat(classes.imageFileName)
      }, attachment.fileName)), /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: "url('".concat(attachment.url, "')")
        },
        className: classes.imageContainer
      })), isValidURL && !isImageFile && /*#__PURE__*/React.createElement("div", {
        className: classes.fileContainer
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "".concat(classes.iconContainer, " ").concat(textStyling)
      }, /*#__PURE__*/React.createElement(CloudDownload, {
        className: classes.icon
      })), /*#__PURE__*/React.createElement(Typography, {
        classes: {
          root: textStyling
        },
        component: "div",
        className: "".concat(classes.fileNameEllipsis, " ").concat(isImageFile === true ? classes.imageFileName : classes.otherFileName)
      }, attachment.fileName)), !isValidURL && /*#__PURE__*/React.createElement("div", {
        className: classes.noFile
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "".concat(classes.iconContainer, " ").concat(textStyling)
      }, /*#__PURE__*/React.createElement(CloudOff, {
        classes: {
          root: textStyling
        },
        className: classes.icon
      })), /*#__PURE__*/React.createElement(Typography, {
        classes: {
          root: textStyling
        },
        component: "div"
      }, t("File not found"))));
    }
  }]);

  return AttachmentBody;
}(PureComponent);

var styles = function styles() {
  return {
    listItem: {
      display: "flex",
      flex: "1",
      position: "relative",
      borderRadius: 12,
      flexDirection: "column",
      overflow: "hidden",
      margin: "0 0 8px 8px"
    },
    imageContainer: {
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: 120
    },
    fileContainer: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: 20
    },
    file: {
      width: "".concat(otherFileW, "px")
    },
    image: {
      width: "".concat(imageFileW, "px")
    },
    cursorPointer: {
      cursor: "pointer"
    },
    imageOverlay: {
      display: "flex",
      position: "absolute",
      flexDirection: "column",
      height: "100%",
      justifyContent: "space-evenly",
      alignItems: "center",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "rgba(255,255,255,.6)",
      transition: "opacity 0.2s ease-out"
    },
    showOverlay: {
      opacity: 1
    },
    hideOverlay: {
      opacity: 0
    },
    iconContainer: {
      width: 30,
      height: 30
    },
    icon: {
      fontSize: 30
    },
    fileNameEllipsis: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginTop: 5,
      textAlign: "center"
    },
    imageFileName: {
      maxWidth: 180
    },
    otherFileName: {
      maxWidth: 100
    },
    noFile: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      marginTop: 20,
      padding: "5px 0 20px 0"
    }
  };
};

export default withStyles(styles)(withi18n(AttachmentBody));
AttachmentBody.default = {
  isCustomer: false
};